import React, { useEffect, useRef } from "react";

interface Props {
  onClickOutside: () => void;
  className?: string;
  children: React.ReactNode;
}

const ClickOutside = (props: Props) => {
  const { onClickOutside, children, className } = props;
  const ref = useRef<HTMLDivElement>(null);
  const onEscape = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      onClickOutside();
    }
  };

  const onClick = (e: MouseEvent | TouchEvent) => {
    if (!ref.current?.contains(e.target as Node)) {
      onClickOutside();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", onEscape);
    document.addEventListener("mousedown", onClick, true);
    document.addEventListener("touchend", onClick, true);

    return () => {
      document.removeEventListener("keydown", onEscape);
      document.removeEventListener("mousedown", onClick, true);
      document.removeEventListener("touchend", onClick, true);
    };
  }, [onClickOutside]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

export default ClickOutside;
